import { render, staticRenderFns } from "./AppointmentRoom.vue?vue&type=template&id=f04750de&"
import script from "./AppointmentRoom.vue?vue&type=script&lang=ts&"
export * from "./AppointmentRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports